import { T19_06 } from "./T19_06"

export const T19_05 = {
    "columns": 12,
    "rows": 1.5,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": 'colorTheme1',
        "title": "Customer Group Growth",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Customer Group',
                        "columnName": 'CustomerGroup',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'Actual Sales',
                        "columnName": 'ActualSales',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'LY Sales',
                        "columnName": 'LYSales',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Growth %',
                        "columnName": 'Growth',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    }
                ],
                "title": "CustomerGroup",
                "endpoint": "T19.5",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" },
                    { "key": "AgentCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": T19_06
                }
            }
        }
    }
}